import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { LucideAngularModule } from 'lucide-angular';
import { filter, map, startWith } from 'rxjs';
import { ChatStatus } from 'src/shared/stores/chat/chat-data.store';
import { ChatFacade } from 'src/shared/stores/chat/chat-facade.store';
import { ChannelMemberResponse } from 'stream-chat';
import { ChatClientService } from 'stream-chat-angular';

/**
 * Chat header component
 * Override component for Stream Chat header.
 */
@Component({
  selector: 'app-chat-header',
  imports: [LucideAngularModule, SvgIconComponent, NgTemplateOutlet],
  templateUrl: './chat-header.component.html',
  styleUrl: './chat-header.component.scss',
})
export class ChatHeaderComponent {
  chatStore = inject(ChatFacade);
  chatClientService = inject(ChatClientService);
  avatarSrc = computed(() => this.chatStore.conn.staff_member_image_url() || '/assets/svgs/joii-logo.svg');
  imageType = computed(() => {
    const url = this.avatarSrc();
    if (!url) return null;
    const cleanUrl = url.split('?')[0];
    const extension = cleanUrl.split('.').pop() || '';
    return extension === 'svg' ? 'svg' : this.supportedImageTypes.includes(extension) ? 'image' : null;
  });
  currentChat = computed(() => {
    const activeChannel = this.chatStore.conn.activeChannel();
    return this.chatStore.data.chats().find((c) => c.channel_id === activeChannel?.id);
  });
  isOnline = this.chatStore.conn.staff_member_online;
  chatStatus = ChatStatus;
  private supportedImageTypes = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'];

  /**
   * Returns the online status of the user and updates it when it changes.
   * @param user
   * @returns
   */
  getOnlineStatus(user: ChannelMemberResponse | null) {
    return this.chatClientService.events$.pipe(
      filter((e) => e.eventType === 'user.presence.changed'),
      map((event) => {
        if (event.event?.user?.id === user?.user?.id) {
          return event.event?.user?.online || false;
        }
        return user?.user?.online || false;
      }),
      startWith(user?.user?.online || false)
    );
  }
}
